module.exports = __webpack_public_path__ + "images/a5-landscape-c4fe946cc183224f7f80728f6aabbb01.jpg";